"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeSearch = void 0;
exports.default = _default;
var _encode = require("./encode");
var _renameField = _interopRequireDefault(require("./rename-field"));
var _assign = _interopRequireDefault(require("lodash/assign"));
var _summary = _interopRequireDefault(require("./summary"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const decoders = [(0, _renameField.default)('K', 'keywords'), (0, _renameField.default)('WH', 'where'), (0, _renameField.default)('WID', 'whereid'), (0, _renameField.default)('I', 'classification'), (0, _renameField.default)('O', 'subclassification'), (0, _renameField.default)('SORT', 'sortmode'), (0, _renameField.default)('D', 'daterange'), (0, _renameField.default)('W', 'worktype'), (0, _renameField.default)('N', 'page'), (0, _renameField.default)('CID', 'companyid'), (0, _renameField.default)('NA', 'nation'), (0, _renameField.default)('L', 'location'), (0, _renameField.default)('A', 'area'), (0, _renameField.default)('ADV', 'advertiserid'), (0, _renameField.default)('ADG', 'advertisergroup'), (0, _renameField.default)('WA', 'workarrangement'), function decodeSalaryType(_ref) {
  let {
    SL
  } = _ref;
  return SL ? {
    salarytype: SL.toLowerCase()
  } : {};
}, function decodeSalaryRange(_ref2) {
  let {
    SF,
    ST
  } = _ref2;
  return SF && ST ? {
    salaryrange: `${SF}-${ST}`
  } : {};
}, function decodeGraduateSearch(_ref3) {
  let {
    C
  } = _ref3;
  return C ? {
    graduatesearch: 'true'
  } : {};
}];
const deserialiseCookie = cookie => {
  const cookieParts = cookie.split('~').map(encoded => {
    const parts = encoded.split('|');
    const key = parts[0];
    const value = parts.slice(1).join('|');
    return value ? {
      [key]: value
    } : {};
  });
  return (0, _assign.default)(...cookieParts);
};
const parseTimestamp = cookie => {
  const timestamp = cookie.OSF && cookie.OSF.split('=')[1];
  return timestamp && /^\d+$/.test(timestamp) ? parseInt(timestamp, 10) : null;
};
const decodeSearch = (cookie, locale) => {
  let decodedCookie;
  try {
    decodedCookie = decodeURIComponent(cookie);
  } catch (e) {
    decodedCookie = cookie;
  }
  const deserialisedCookie = deserialiseCookie(decodedCookie);
  const decodedParts = decoders.map(decode => decode(deserialisedCookie));
  const query = (0, _assign.default)(...decodedParts);
  const timestamp = parseTimestamp(deserialisedCookie);
  if (!timestamp) {
    return null;
  }
  return {
    query,
    date: new Date(timestamp),
    summary: (0, _summary.default)(query, locale)
  };
};
exports.decodeSearch = decodeSearch;
function _default(cookie, locale) {
  if (!cookie) {
    return null;
  }
  const parsedSearches = cookie.split(_encode.searchSeparator).map(search => decodeSearch(search, locale)).filter(Boolean);
  const {
    query: parsedQuery,
    date: parsedDate,
    summary: parsedSummary
  } = parsedSearches[0] || {};
  return parsedSearches.length > 0 ? {
    query: parsedQuery,
    date: parsedDate,
    summary: parsedSummary,
    searches: parsedSearches
  } : null;
}